import api from 'api';
import { actions } from 'store';
import { useDispatch, useReduxState } from 'hooks';
import { ModalButtonWithForm } from 'components/common';
import { SortableListInput } from 'components/common/form';

interface Props {
  attributes: any;
  updateData: () => Promise<void>;
}

const UserAttributesOrder = ({ attributes, updateData }: Props) => {
  const { dispatch } = useDispatch();

  const { messages } = useReduxState();

  const handleSubmit = async ({ attributeIds }) => {
    await api.post('/admin/user-custom-attributes-order', { attributeIds });

    await updateData();

    dispatch(
      actions.addNotice({
        text: messages.commonEditOrderSuccess,
        type: 'success'
      })
    );
  };

  const labels: { [id: string]: string } = {};

  attributes.forEach((attribute) => {
    labels[attribute.id] = attribute.title;
  });

  const initialValues = {
    attributeIds: attributes.map((attribute) => attribute.id)
  };

  return (
    <ModalButtonWithForm
      buttonCategory="light"
      buttonDisabled={!attributes}
      buttonIcon="arrows-alt-v"
      buttonIsDropdown={true}
      buttonSize="header"
      buttonText={messages.commonEditOrder}
      contentStyle={{ padding: 0 }}
      initialValues={initialValues}
      modalActionCategory="success"
      modalActionText={messages.commonUpdate}
      modalTitle={messages.commonEditOrder}
      onSubmit={handleSubmit}
      pristineIsValid={false}
    >
      {() => (
        <SortableListInput
          itemWithBorder={true}
          labels={labels}
          field="attributeIds"
        />
      )}
    </ModalButtonWithForm>
  );
};

export default UserAttributesOrder;
